<template>
  <banner v-if="(showBanners && slides.length>0)" :slides="slides" :key="mfID" :startingSlide="slideStartsAt">
    <template v-if="isScienceDay" v-slot:title="{ title: { title: { imageAltText } } }">
      <section class="data-container">
        <div class="is-flex">
          <div class="logo-container">
            <img src="https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/science-day-banner%2FLogo.png?alt=media&token=d103f425-a89f-4809-92e8-11e7b3bfecc9"
                 class="logo-container_img"
                 :alt="imageAltText"/>
          </div>
          <div class="line-container">
            <img src="https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/science-day-banner%2FRectangle%20261.png?alt=media&token=f72fe7e1-febd-4cf6-b105-fa0bc6fcdc3c"
                 :alt="imageAltText"/>
          </div>
          <div class="text-container">
            <h2 class="title is-uppercase text-header">WELCOME ALL!</h2>
            <p class="description-container">Explore and engage on projects from Ohio's bright young minds who go above and beyond through their scientific research. Qualifying projects advance to
              compete for nearly $400k in scholarships!</p>
          </div>
        </div>
      </section>
    </template>
    <template v-else-if="isBuckeye" v-slot:title="{ title: { title: { imageAltText } } }">>
      <section class="data-container">
        <div class="bg-bsef">
          <div class="is-flex">
            <div class="logo-container">
              <img src="https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/banners%2FBuckeye%2Fbsef-logo.jpg?alt=media&token=96f771be-39bc-4126-9f29-e0d87be21090"
                   class="logo-container_img"
                   :alt="imageAltText"/>
            </div>
            <div class="text-container">
              <h2 class="banner-text">Finalist Exhibit Hall</h2>
              <p class="banner-desc">The Buckeye Science & Engineering Fair (BSEF) provides all Ohio’s students in grades 9-12 with an opportunity to qualify for the International Science & Engineering Fair (ISEF). The ISEF is the largest and most prestigious science fair in the world. Each year over 1,700 students from more than 70 countries, regions, and territories around the world gather to compete for nearly $5,000,000 in awards and scholarships.</p>
            </div>
          </div>
        </div>
      </section>
    </template>
  </banner>
</template>

<script>
import vmfBanner from './vmfBanner'
import Banner from './Banner'

import breakpoints from '@/libs/breakpoints'
import auth from '@/mixins/auth'
import utmTracking from '@/mixins/utm-tracking'
import categorySets from '@/mixins/category-set'

export default {
  props: ['isScienceDay', 'isBuckeye'],
  mixins: [auth, vmfBanner, utmTracking, categorySets],
  components: {
    Banner
  },
  data: function () {
    return {
      category: '',
      categoryID: 0,
      slides: [],
      showBanners: false,
      banners: [],
      categoryBanners: [],
      showLearnModal: false,
      startingSlide: 1,
      singleStartingSlide: 1,
      mfID: 0,
      image: ''
    }
  },
  computed: {
    slideStartsAt: function () {
      const slideStartAt = this.startingSlide
      return slideStartAt
    },
    appName: function () {
      return process.env.APP_NAME.toLowerCase()
    },
    isCategoryBanner: function () {
      return this.singleSlide.filter(slide => (slide.category === this.$route.params.category)).length === 1
    },
    isMobile: function () {
      return breakpoints.isMobile()
    }
  },
  watch: {
    $route () {
      this.getSlides()
    }
  },
  mounted () {
    this.getSlides()
  },
  methods: {
    reset: function () {
      this.showBanners = false
      this.slides = []
    },
    getSlides: async function () {
      this.reset()
      await this.getCategoryObj()
      let categorySlug = ''
      if (this.isScienceDay || this.isBuckeye) {
        categorySlug = this.$route.path.substring(1)
      }
      const catSets = await this.getCategorySetsForCategoryPage(this.appName, this.categoryID, categorySlug)
      const catBtns = await this.getBannerButtonsForCategoryPage(this.appName, this.categoryID)

      let btnCheck = false
      for (let i = 0; i < catSets.length; i++) {
        // Initialize JSON
        const emp = {}
        emp.content = {}
        emp.content.link = {}
        emp.content.button = {}

        emp.id = catSets[i].id
        emp.title = {
          title: catSets[i].title,
          image: catSets[i].image,
          imageAltText: catSets[i].imageAltText
        }
        emp.description = catSets[i].description
        emp.background = {
          image: catSets[i].background_image
        }
        for (let j = 0; j < catBtns.length; j++) {
          if (catSets[i].id === parseInt(catBtns[j].banner_id)) {
            if (!btnCheck) {
              emp.content.link.show = true
              emp.content.link.text = catBtns[j].text
              emp.content.link.url = catBtns[j].link
              emp.content.link.paramName = catBtns[j].option_name
              emp.content.link.paramValue = catBtns[j].option_value
              btnCheck = true
            } else {
              emp.content.button.show = true
              emp.content.button.text = catBtns[j].text
              emp.content.button.url = catBtns[j].link
              emp.content.button.paramName = catBtns[j].option_name
              emp.content.button.paramValue = catBtns[j].option_value
              btnCheck = false
            }
          }
        }
        btnCheck = false
        this.slides.push(emp)
      }
    },
    getCategoryObj: async function () {
      if (this.$route.params.category && this.$route.params.category.length > 0) {
        this.category = this.$route.params.category
      } else {
        this.category = this.$route.query.category
      }
      try {
        this.categoryObj = await this.getShowBannerForCategoryFlag(this.category)
        if (this.categoryObj !== null) {
          this.categoryID = this.categoryObj.id
          this.showBanners = this.categoryObj.showBanner
        }
        if (this.$route.path === '/home' || this.$route.path === '/viewAll' || this.$route.path === '/scienceday' || this.$route.path === '/bsef') {
          this.showBanners = true
        } else {
          this.showBanners = false
        }
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';

.bg-bsef {
  background: rgba(14,55,99,.8);
  padding: 0 25px;
}

.banner-text {
  font-size: 1.8em;
  font-weight: 600;
  padding: 10px 0;
}

.banner-desc {
  font-size: 1.05em;
}

::v-deep .slide29 {
  background-position: center;
  .text {
    display: none;
  }
}
.data-container {
  width: 100vw;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-left: -8rem;
  @media (max-width: 1024px) {
    margin-top: -8rem;
  }
  @media (max-width: 450px) {
    margin-left: -1.4rem;
  }
}
.logo-container {
  height: 20rem;
  width: 20rem;
  margin-top: 170px;
  @media (max-width: 1024px) {
    height: 15rem;
    width: 15rem;
    margin-top: 210px;
  }
  @media (max-width: 820px) {
    height: 15rem;
    width: 15rem;
    margin-top: 200px;
  }
  @media (max-width: 450px) {
    height: 10rem;
    width: 10rem;
    margin-top: 210px;
  }
}
.line-container {
  margin-left: 2rem;
  height: 7px;
  width: 7px;
  margin-top: 170px;
  @media (max-width: 1024px) {
    height: 7px;
    width: 7px;
    margin-left: 1rem;
    margin-right: 0.5rem;
    margin-top: 178px;
  }
  @media (max-width: 820px) {
    height: 6.5px;
    width: 6.5px;
    margin-left: 0.8rem;
    margin-top: 178px;
  }
  @media (max-width: 414px) {
    height: 6px;
    width: 6px;
    margin-left: 0.5rem;
    margin-top: 178px;
    margin-right: 0.1rem;
  }
  @media (max-width: 375px) {
    height: 6px;
    width: 6px;
    margin-left: 0.5rem;
    margin-top: 190px;
    margin-right: -0.2rem;
  }
  @media (max-width: 360px) {
    height: 6px;
    width: 6px;
    margin-left: 0.5rem;
    margin-top: 190px;
  }
}
.text-container {
  margin-top: 170px;
  height: 50px;
  width: 31rem;
  margin-left: 2rem;
  @media (max-width: 1024px) {
    height: 50px;
    width: 20rem;
    margin-top: 190px;
    margin-left: 1rem;
  }
  @media (max-width: 820px) {
    height: 50px;
    width: 20rem;
    margin-top: 190px;
    margin-left: 1rem;
  }
  @media (max-width: 450px) {
    height: 50px;
    width: 10.5rem;
    margin-left: 1rem;
    margin-top: 11rem;
  }
}
.text-header {
  color: rgb(0, 91, 171);
  font-weight: 900;
  font-size: 2.8rem;
  @media (max-width: 1024px) {
    font-weight: 900;
    font-size: 2rem;
  }
  @media (max-width: 820px) {
    font-weight: 900;
    font-size: 1.5rem;
  }
  @media (max-width: 414px) {
    font-weight: 900;
    font-size: 1.3rem;
  }
  @media (max-width: 375px) {
    font-weight: 900;
    font-size: 1.3rem;
  }
  @media (max-width: 360px) {
    font-weight: 900;
    font-size: 1.3rem;
  }
}
.description-container {
  color: rgb(9, 10, 10);
  font-weight: 700;
  font-size: 1.2rem;
  @media (max-width: 1024px) {
    font-weight: 700;
    font-size: 1rem;
    margin-top: -1rem;
  }
  @media (max-width: 820px) {
    font-weight: 700;
    font-size: 1rem;
    margin-top: -1rem;
  }
  @media (max-width: 414px) {
    font-weight: 700;
    font-size: 0.8rem;
    margin-top: -1rem;
  }
  @media (max-width: 375px) {
    font-weight: 700;
    font-size: 0.8rem;
    margin-top: -1rem;
  }
  @media (max-width: 360px) {
    font-weight: 700;
    font-size: 0.8rem;
    margin-top: -1rem;
  }
}

</style>
